import { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const form = e.currentTarget as HTMLFormElement;
    const hpField = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (hpField && hpField.value.trim() !== "") {
      setStatus("success");
      setEmail("");
      setTimeout(() => setStatus("idle"), 3000);
      return;
    }

    try {
      const formData = new URLSearchParams();
      formData.append("email", email);

      const response = await fetch("https://readdy.ai/api/form/d8vo68g4jh3v1cgksghg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });

      if (response.ok) {
        setStatus("success");
        setEmail("");
        setTimeout(() => setStatus("idle"), 3000);
      } else {
        setStatus("error");
        setTimeout(() => setStatus("idle"), 3000);
      }
    } catch {
      setStatus("error");
      setTimeout(() => setStatus("idle"), 3000);
    }
  };

  return (
    <footer className="w-full bg-foreground-950 rounded-t-3xl mt-8">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand Column */}
          <div>
            <Link
              to="/"
              className="text-white text-xl font-bold whitespace-nowrap cursor-pointer"
            >
              CSSBuy<span className="font-light text-white/60">.run</span>
            </Link>
            <p className="text-white/40 text-sm mt-4 leading-relaxed">
              O maior CSSBuy Spreadsheet em português. Links verificados,
              atualizados semanalmente, com guias completos para Portugal e
              Brasil.
            </p>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">
              Navegação
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link
                to="/"
                className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                Página Inicial
              </Link>
              <Link
                to="/artigo/cssbuy-spreadsheet-guia-completo"
                className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                Guia Completo CSSBuy
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                CSSBuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                Explorar Produtos
              </a>
            </div>
          </div>

          {/* Social Column */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Social</h4>
            <div className="flex flex-col gap-2.5">
              <a
                href="#"
                target="_blank"
                rel="noopener nofollow"
                className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 cursor-pointer inline-flex items-center gap-2 whitespace-nowrap"
              >
                <i className="ri-twitter-x-line"></i> Twitter / X
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener nofollow"
                className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 cursor-pointer inline-flex items-center gap-2 whitespace-nowrap"
              >
                <i className="ri-reddit-line"></i> Reddit
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener nofollow"
                className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 cursor-pointer inline-flex items-center gap-2 whitespace-nowrap"
              >
                <i className="ri-discord-line"></i> Discord
              </a>
            </div>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-2">
              Newsletter
            </h4>
            <p className="text-white/40 text-xs mb-4">
              Receba as atualizações da planilha
            </p>
            <form
              onSubmit={handleSubmit}
              data-readdy-form
              className="flex gap-2"
            >
              <input
                type="text"
                name="website_alt"
                className="form-hp-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
              />
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
                className="flex-1 bg-white/10 border border-white/20 rounded-full px-4 py-2.5 text-white text-sm placeholder:text-white/30 focus:outline-none focus:border-white/40 transition-colors duration-200"
              />
              <button
                type="submit"
                className="w-10 h-10 bg-white rounded-full flex items-center justify-center cursor-pointer hover:bg-white/90 transition-all duration-200 flex-shrink-0"
                aria-label="Subscrever"
              >
                <i className="ri-arrow-right-line text-foreground-950"></i>
              </button>
            </form>
            {status === "success" && (
              <p className="text-accent-300 text-xs mt-2">
                Subscrição confirmada!
              </p>
            )}
            {status === "error" && (
              <p className="text-red-400 text-xs mt-2">
                Erro. Tente novamente.
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-white/30 text-xs">
          &copy; {new Date().getFullYear()} CSSBuy.run — Todos os direitos
          reservados.
        </p>
        <p className="text-white/20 text-xs">
          CSSBuy Spreadsheet Portugal e Brasil 2026
        </p>
      </div>
    </footer>
  );
}